import React from "react";
import { useUrl } from "@/context/SiteContext";
import ServicePage from "./ServicePage";

export default function StudiuIdentificareSolutieITPage() {
  const url = useUrl();
  return (
    <ServicePage
      backLabel="Audituri"
      backTo={url.dept("audituri")}
      number="01"
      eyebrow="Audit digitalizare"
      title={["Studiu privind", "identificarea", "soluției IT."]}
      tagline="Analiza care traduce nevoile companiei tale în specificațiile tehnice ale unui proiect de digitalizare — bază solidă pentru finanțare și implementare."
      intro={[
        "Studiul privind identificarea soluției IT este documentul-cheie prin care alegem tehnologiile potrivite pentru operațiunile tale, în conformitate cu obiectivele proiectului și cerințele finanțatorului.",
        "Echipa SUNTEC analizează pe teren infrastructura existentă, procesele operaționale și fluxurile de date, apoi propune un set clar de soluții hardware, software și integrări — cu bugete, dependențe și repere de implementare.",
        "Documentul devine referința utilizată în cererea de finanțare, în achiziții și în auditul final — asigură coerența întregului proiect de digitalizare, de la brief la recepție.",
      ]}
      bullets={[
        "Inventar tehnic complet: echipamente, licențe, viteze, arhitectură rețea.",
        "Analiza proceselor și identificarea zonelor cu potențial maxim de automatizare.",
        "Recomandări prioritizate — hardware, software, integrări, servicii complementare.",
        "Compatibilitate cu ghidurile de finanțare și cu criteriile DESI aplicabile.",
      ]}
      stepsEyebrow="Metodologia SUNTEC"
      stepsTitle="Trei pași până la documentul livrat."
      steps={[
        {
          title: "Consultanță",
          desc: "Analizăm nevoile companiei și propunem direcții adaptate fiecărei situații identificate în teren.",
        },
        {
          title: "Planificare",
          desc: "Supraveghem și coordonăm fiecare fază — de la brief la lista de echipamente și calendar.",
        },
        {
          title: "Implementare",
          desc: "Echipele cu peste 20 de ani de experiență duc soluția în producție și pregătesc dosarul de decontare.",
        },
      ]}
    />
  );
}
